export default __webpack_public_path__ + "static/media/github.ef74d4f6.svg";